import React from 'react'
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
// Custom
import New from 'views/new';

export default function Routes() {
    React.useEffect(() => {
        AOS.init();
    });
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" render={(props) => <New {...props} />} />
                </Switch>
            </BrowserRouter>
        </>
    )
}